export default "__VITE_ASSET__DsIzmVkA__"